export const loadEnv = () => {
  const { SSR_FOOTER_STATE: state } = window;

  if (state === undefined) {
    console.warn('ssr state not found: no environment loaded'); // eslint-disable-line no-console
    return;
  }

  const { __environment__: environment } = state;
  Object.entries(environment).forEach(([key, value]) => {
    process.env[key] = value;
  });

  if (environment.REACT_APP_ASSETS_BASE_URL) {
    __webpack_public_path__ = environment.REACT_APP_ASSETS_BASE_URL; // eslint-disable-line
  }
};
